export default __webpack_public_path__ + "static/media/industrial.2da68bd8.jpg";